// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"building-5"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 21V12.8889L12 8L20 12.8889V21H4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M6 11.6667V5.85699L11.9984 2L18 5.85729V11.6667L12 8L6 11.6667Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 17V21M19 6.5L11.9984 2L5 6.5M6 6.35V11.6667L12 7.99999L18 11.6667V6.3503","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 13.5L12 8L21 13.5M4 13.4V21H20V13.4","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Building5Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'building-5',
    ref,
    icon: element,
  },
));

Building5Icon.displayName = 'Building5Icon';

export default Building5Icon;
